import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CarouselControls, CarouselNavigation, CarouselPagination, CarouselSlide, Carousel as DSCarousel } from "@cinch-labs/design-system";
import cx from "classnames";
import styles from "./carousel.module.css";
import { VehicleCard } from "@cinch-nx/landing-ui-shared";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
export const Carousel = ({ carouselName , vehicles  })=>{
    const { trackEvent  } = useAnalytics();
    const navAriaLabels = {
        previous: "Go to previous slide",
        next: "Go to next slide"
    };
    if (!vehicles) {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.carouselLoading,
            children: "Loading..."
        });
    }
    const vehiclesInStock = vehicles.slice(0, 6);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(DSCarousel, {
                name: carouselName,
                swiperSettings: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    breakpoints: {
                        564: {
                            slidesPerView: 1
                        },
                        768: {
                            slidesPerView: 2
                        },
                        1024: {
                            slidesPerView: 3
                        }
                    }
                },
                ariaLabel: `${carouselName}-carousel`,
                children: vehiclesInStock.map((vehicle)=>/*#__PURE__*/ _jsx(CarouselSlide, {
                        children: /*#__PURE__*/ _jsx(VehicleCard, {
                            vehicle: vehicle,
                            id: "vehicles-in-stock-carousel",
                            isSaved: false,
                            isPending: false,
                            isAvailable: vehicle.isAvailable,
                            onCardClick: ()=>{
                                trackEvent({
                                    eventName: `Cars in stock at cinch store`,
                                    type: TrackingEventTypes.ADOBE,
                                    data: {
                                        event: {
                                            name: EventNames.click,
                                            category: "Cars in stock at cinch store",
                                            type: vehicle.site,
                                            label: "pdp card",
                                            action: vehicle.vehicleId
                                        }
                                    }
                                });
                            }
                        })
                    }, vehicle.vehicleId))
            }),
            /*#__PURE__*/ _jsxs(CarouselControls, {
                customClassNames: styles.controlsWrapper,
                children: [
                    /*#__PURE__*/ _jsx(CarouselPagination, {
                        name: carouselName,
                        className: cx(`${carouselName}-pagination`, styles.pagination, styles.customPagination),
                        "data-testid": "ds-carousel-pagination",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ _jsx(CarouselNavigation, {
                        name: carouselName,
                        ariaLabels: navAriaLabels,
                        ariaHidden: true,
                        customClassNames: {
                            prevButton: styles.prevButton,
                            nextButton: styles.nextButton
                        }
                    })
                ]
            })
        ]
    });
};
